<div class="divider-bar mb-21 mt-27 mct-flex mct-row mct-justify-between mct-items-center"  >
  <h4 class="mb-27">{{ 'revenue.credit-card-activity.credit-card-activity' | translate | titlecase }}</h4>
  <a class="mct-flex mct-row mct-justify-end mct-items-center" *ngIf="arbEnabled"   href="/revenue/arbcreation">ARB Creation Activity</a>
</div>
<div class="params-container mb-27 mct-flex mct-col mct-gap-27"  >
  <div>
    <span class="section-header">{{ 'revenue.credit-card-activity.search-credit-card-activity' | translate | titlecase }}</span>
  </div>
  <div class="mct-flex mct-row mct-gap-27"   [wl-busy-overlay]="busy" [busyCenter]="true">
    <div class="mct-flex mct-col" >
      <label>
        {{ 'revenue.credit-card-activity.start-date' | translate | ucfirst }}
      </label>
      <wl-date-selector #starDate appendTo="body" [(ngModel)]="searchParams.StartDate"></wl-date-selector>
    </div>
    <div class="mct-flex mct-col" >
      <label>
        {{ 'revenue.credit-card-activity.end-date' | translate | ucfirst }}
      </label>
      <wl-date-selector #endDate appendTo="body" [(ngModel)]="searchParams.EndDate"></wl-date-selector>
    </div>
    <div class="mct-flex mct-col" >
      <label>
        {{ 'revenue.credit-card-activity.credit-card-gateway' | translate | ucfirst }}
      </label>
      <p-select
        #ccGateWayId
        placeholder="{{ 'revenue.credit-card-activity.select-a-gateway' | translate | ucfirst }}"
        [options]="creditCardGateways"
        [(ngModel)]="searchParams.CcGatewayId"
        appendTo="body"
        [style]="{ 'min-width': '300px' }"
      ></p-select>
    </div>
  </div>
  <div class="mt-33 mct-flex mct-row mct-justify-end mct-items-center"  >
    <button pButton type="button" class="atlas-btn atlas-btn-primary" (click)="search()">
      {{ 'common.run-this-search' | translate | uppercase }}
    </button>
  </div>
</div>
<div class="divider-bar mb-21 mct-flex mct-row mct-justify-between mct-items-center"  >
  <div>
    <button pButton type="button" class="btn btn-default" (click)="exportClick()" [disabled]="exporting">
      <wl-busy *ngIf="exporting" [show]="exporting"></wl-busy>
      <span [hidden]="exporting">{{ 'common.export' | translate | titlecase }}</span>
      <span [hidden]="!exporting">{{ 'common.exporting' | translate | titlecase }}</span>
    </button>
  </div>
  <div class="mct-flex mct-row mct-justify-end mct-items-center"  >
    <span *ngIf="!searchResult?.length; else resultsReturned" class="no-results">
      {{ 'common.no-search-results' | translate | ucfirst }}
    </span>
    <ng-template #resultsReturned>
      <span>{{ 'common.the-search-returned' | translate | ucfirst }}</span>
      &nbsp;
      <span class="f-wb">{{ searchResult.length }}</span>
      &nbsp;
      <span class="f-wb">{{ 'revenue.credit-card-activity.instances' | translate }}</span>
    </ng-template>
    <button pButton type="button"  class="mct-flex ml-10 atlas-btn atlas-btn-secondary mct-justify-center mct-items-center" type="button" (click)="clear()">
      <i class="large-icon pi pi-times"></i>
      <span>{{ 'common.clear-search' | translate | uppercase }}</span>
    </button>
  </div>
</div>
<div class="atlas-table" [hidden]="searchResult.length == 0">
  <p-table [showGridlines]="true" [value]="searchResult" [paginator]="true" [rows]="pageSize" [(first)]="first" [totalRecords]="searchResult.length">
    <ng-template pTemplate="sorticon" field="col.field" let-sortOrder>
      <SortAltIcon *ngIf="sortOrder === 0">
        <span><i class="p-sortable-column-icon pi pi-fw pi-sort-alt" aria-hidden="true"></i></span>
      </SortAltIcon>
      <SortAmountUpAltIcon *ngIf="sortOrder === 1" [styleClass]="'p-sortable-column-icon'">
        <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-up-alt" aria-hidden="true"></i></span>
      </SortAmountUpAltIcon>
      <SortAmountDownIcon *ngIf="sortOrder === -1" [styleClass]="'p-sortable-column-icon'">
        <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-down" aria-hidden="true"></i></span>
      </SortAmountDownIcon>
    </ng-template>
    <ng-template pTemplate="header">
      <tr>
        <th pSortableColumn="InvoiceNum">
          {{ 'revenue.credit-card-activity.invoice-num' | translate | ucfirst }}
          <p-sortIcon field="InvoiceNum"></p-sortIcon>
        </th>
        <th pSortableColumn="CurrentState">
          {{ 'revenue.credit-card-activity.processed' | translate | ucfirst }}
          <p-sortIcon field="CurrentState"></p-sortIcon>
        </th>
        <th pSortableColumn="Amount">
          {{ 'revenue.credit-card-activity.amount' | translate | ucfirst }}
          <p-sortIcon field="Amount"></p-sortIcon>
        </th>
        <th pSortableColumn="ReportName" style="width: 396px">
          {{ 'revenue.credit-card-activity.profile' | translate | ucfirst }}
          <p-sortIcon field="ReportName"></p-sortIcon>
        </th>
        <th pSortableColumn="PaymentDate" style="width: 139px">
          {{ 'revenue.credit-card-activity.payment-date' | translate | ucfirst }}
          <p-sortIcon field="PaymentDate"></p-sortIcon>
        </th>
        <th pSortableColumn="NameOnCard" style="width: 220px">
          {{ 'revenue.credit-card-activity.name-on-card' | translate | ucfirst }}
          <p-sortIcon field="NameOnCard"></p-sortIcon>
        </th>
        <th pSortableColumn="RevenueItemName">
          {{ 'revenue.credit-card-activity.revenue-item' | translate | titlecase }}
          <p-sortIcon field="RevenueItem"></p-sortIcon>
        </th>
        <th [style]="{ width: '120px' }"></th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-transactionSummaryItem>
      <tr>
        <td class="t-al">{{ transactionSummaryItem.InvoiceNum }}</td>
        <td class="t-ac">
          <div [ngSwitch]="transactionSummaryItem.CurrentState">
            <span *ngSwitchCase="transactionStateEnum.Processed" class="pi pi-check f-green"></span>
            <span *ngSwitchCase="transactionStateEnum.Refunded" class="f-grey">
              {{ 'revenue.credit-card-activity.refunded' | translate | uppercase }}
            </span>
            <span *ngSwitchCase="transactionStateEnum.Voided" class="f-grey">
              {{ 'revenue.credit-card-activity.voided' | translate | uppercase }}
            </span>
            <span *ngSwitchCase="transactionStateEnum.Undefined" class="alert-icon">
              <img src="/assets/img/alert-icon.svg" />
            </span>
          </div>
        </td>
        <td class="t-ar">{{ transactionSummaryItem.Amount | currency }}</td>
        <td>
          <wl-profile-type-icon class="ml-10px" [profileId]="transactionSummaryItem.ProfileId"></wl-profile-type-icon>
          {{ transactionSummaryItem.ReportName }}
        </td>
        <td>{{ transactionSummaryItem.PaymentDate | date : 'MM/dd/yyyy' }}</td>
        <td>{{ transactionSummaryItem.NameOnCard }}</td>
        <td>{{ transactionSummaryItem.RevenueItem }}</td>
        <td class="t-ac">
          <button pButton type="button" (click)="detailsDialog.open(transactionSummaryItem)">{{ 'common.details' | translate | uppercase }}</button>
          <div *wlAccessControl="securityElementNames.fullAccess(securityElementNames.Manage_Member_Codes)"></div>
        </td>
      </tr>
    </ng-template>
  </p-table>
<p-progressSpinner *ngIf="busy"></p-progressSpinner>
  <wl-page-size-dropdown [(pageSize)]="pageSize" [pageSizes]="[20, 100, 0]" (pageSizeChange)="first = 0"></wl-page-size-dropdown>
</div>

<wl-credit-card-activity-details-dialog #detailsDialog></wl-credit-card-activity-details-dialog>
